// Be sure to add the export of the class to the structures.ts file one folder up.
// This should match any models defined on the server side /Models folder that will be passed down.

import { StandardApiError } from "./standardApiError";

export class UserInfo
{
    userId: string;
    firstName: string;
    lastName: string;
    displayName: string;
    needsPIN: boolean;
    needsSecurityQuestions: boolean;
    needsExternalEmail: boolean;
    needsPasswordReset: boolean;
    isExternalMailSkipped: boolean;
    isNetworkUser: boolean;
    reverificationRequiredForSecurityQuestions: boolean;
    reverificationRequiredForExternalEmail: boolean;
    reverificationRequiredForPin: boolean;
}

export class LoginData
{
    loginOptions: LoginOption[];
    needsTwoFactorAuth: boolean;
    password: string;
    securityQuestions: SecurityQuestions[];
    mfaPasscode: string;
    externalEmailIdCode: string;
    securityAnswer1: string;
    securityQuestionId1: number;
    securityAnswer2: string;
    securityQuestionId2: number;
    appIdRequestorData: AppIdRequestorData;
    isUserAccountLocked: boolean;
    isPINRegistered: boolean;
    userId: string;
    isExternalAccess: boolean;
    isAdfsAccess: boolean;
    friendlyCaptchaToken: string;
    culture: string;
    isThisTwoFactorAuth: boolean;
}

export class LoginOption
{
    name: string;
    desc: string;
}

export class SecurityQuestions
{
    securityQuestionId: number;
    culture: string;
    securityQuestion: string;
}

export class AppIdRequestorData {
    canRequestAppId: boolean;
    reason: string;
    requestorName: string;
    managerName: string;
    managerEmailID: string;

}
export class LoginUserInfo {
    userId: string;
    culture: string;
}
export class DeviceInfo {
    user_id: string;
    status: string;
    language: string;
    platform: string;
    model: string;
    display_name: string;
    email_address: string;
    uuid: string;
    client_name: string;
    isError: string;
    isUnlocked: boolean = false;
    registration_status: string;
}

export class AdmAccountsInfo {
    admAccountId: string;
    status: string;
}

export class DeviceResponse {
    devicesInfo: DeviceInfo[];
    totalCount: string;
    resultCount: string;
}

export class DeviceLockResponse {
    actionType: string;
    deviceResults: any[];
    successful: string;//True/False
    isError: string;
}

export class SDContactsToDisplay {
    u_country: string;
    u_support_desk: string;
    u_phone_number: string;
    sys_updated_on: string;
}

export class UserDetail {
    userId: string;
    userType: string;
    firstName: string;
    lastName: string;
    password: string;
}

export class PasswordValidationDisplayMessage {
    error: string;
    word: string;
}

export class PasswordValidationMessage {
    errorKey: string;
    errorValue: string;
}


export class PasswordValidationResponse {
    isError: boolean;
    errorCount: number;
    errors: Array<PasswordValidationMessage>
}

export class FriendlyCaptchaResponse {
    success: boolean;
    details: string;
    errors: string;
    standardApiError: StandardApiError;
}

export class Ws_UserRole {
    userRoleId: string;
    userId: string;
    applicationName: string;
    roleName: string;
    envirCode: string 
    statusCode: string;
    statusDate: Date; 
    applicationId: number;
    roleId: number;
    applicationLabel: string;
    roleLabel: string;
    applicationTypeLabel: string; 
}

export class WebServiceApplication {
    id: string;
    name: string;
    label: string;
    applicationRoles: Array<WebServiceApplicationRole>;
   
}

export class WebServiceApplicationRole {
    id: string;
    name: string;
    label: string;
    description: string;
    roleTypeName: string;
    roleClass: string;
    envirCode: string;
    roleRstrn: Array<WebServiceRoleRstrn>
}

export class WebServiceRoleRstrn {
    rstrnId: string;
    name: string;
    sequenceNumber: number;
}

export class RequestInput {
    businessReason: string;
    requestorUserId: string;
    userRoles: Array<RequestUserRoleInput>;
}
export class RequestUserRoleInput {
    userId: string;
    application: string;
    role: string;
    envirCode: string;
    attributes: Array<UserRoleAttributeInput>;
}
export class UserRoleAttributeInput {
    name: string;
    value: string;
}

export class RequestOutput {
    requestId: number;
    requestUserId: string;
    requestFirstName: string;
    requestLastName: string;
    requestEmailAddress: string;
    businessReason: string;
    userRoles: Array<UserRoleOutput>;
}

export class UserRoleOutput {
    userRoleId: number;
    userId: string;
    firstName: string;
    lastName: string;
    emailAddress: string;
    application: string;
    role: string;
    envir: string;
    workflows: Array<WorkflowOutput>;
    attributes: Array<UserRoleAttributeOutput>;
}

export class WorkflowOutput {
    workflowId: number;
    approverUserId: string;
    approverFirstName: string;
    approverLastName: string;
    approverEmailAddress: string;
    routingDescription: string;
    authStatusCode: string;
    sequenceNumber: number;
}

export class UserRoleAttributeOutput {
    name: string;
    value: string;
    sequenceNumber: number;
}

export class SecQuestionAndDaysSinceReverification {
    securityQuestions: SecurityQuestions[];
    daysElapsed: number;
}


